import { c as _c } from "react/compiler-runtime";
import type { Course, TableOfContent } from '@openclassrooms/sdk-web';
import { ChapterLearningStatus } from './LearningStatus';
import useChapterLearningStatus from '../../_hooks/useChapterLearningStatus';
import TocItemWrapper from './TocItemWrapper';
export interface Props {
  number: number;
  categoryColor: string;
  currentChapterId: number;
  chapterPart: TableOfContent;
  isOnHomePage: boolean;
  course: Course;
  onClick?: () => void;
}
const ChapterTocItem = t0 => {
  const $ = _c(17);
  const {
    categoryColor,
    currentChapterId,
    number,
    chapterPart,
    isOnHomePage,
    course,
    onClick: t1
  } = t0;
  const onClick = t1 === undefined ? _temp : t1;
  const {
    id,
    title,
    learningActivityStatus
  } = chapterPart;
  let t2;
  if ($[0] !== course || $[1] !== currentChapterId || $[2] !== id || $[3] !== isOnHomePage || $[4] !== learningActivityStatus) {
    t2 = {
      id,
      initialStatus: learningActivityStatus,
      isOnHomePage,
      course,
      currentChapterId
    };
    $[0] = course;
    $[1] = currentChapterId;
    $[2] = id;
    $[3] = isOnHomePage;
    $[4] = learningActivityStatus;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    status: chapterLearningStatus
  } = useChapterLearningStatus(t2);
  const isCurrentlyDisplayed = id === Number(currentChapterId);
  let t3;
  if ($[6] !== categoryColor || $[7] !== chapterLearningStatus || $[8] !== number) {
    t3 = <ChapterLearningStatus status={chapterLearningStatus} chapterIndex={number} color={categoryColor} />;
    $[6] = categoryColor;
    $[7] = chapterLearningStatus;
    $[8] = number;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const Icon = t3;
  let t4;
  if ($[10] !== Icon || $[11] !== chapterPart || $[12] !== course || $[13] !== isCurrentlyDisplayed || $[14] !== onClick || $[15] !== title) {
    t4 = <TocItemWrapper isCurrentlyDisplayed={isCurrentlyDisplayed} part={chapterPart} label={title} course={course} onClick={onClick} learningStatusIcon={Icon} />;
    $[10] = Icon;
    $[11] = chapterPart;
    $[12] = course;
    $[13] = isCurrentlyDisplayed;
    $[14] = onClick;
    $[15] = title;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export default ChapterTocItem;
function _temp() {}